import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { GlobalsService, SubscribeService } from '@services';
import { MessageService } from 'primeng/api';
import { APP_LANGUAGES } from 'src/core/constants/application-languages';
import { Portal } from 'src/core/models/common/portal.model';
import { I18NService } from 'src/core/services/i18n/i18n.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    providers: [MessageService],
})
export class FooterComponent implements OnInit {
    readonly env = environment;
    readonly APP_LANGUAGES = APP_LANGUAGES;
    // subscribeEmail: string;
    language: string;
    currentDate = new Date();
    form: FormGroup;
    selectedPortals: Portal[];
    portals: Portal[];
    tags: string[] = [];
    constructor(
        @Inject(PLATFORM_ID) private platformId: object,
        private globals: GlobalsService,
        private messageService: MessageService,
        private subscribeService: SubscribeService,
        public i18n: I18NService,
        public fb: FormBuilder,
        private translator: TranslateService,
    ) {
        if (this.env.needProtect) {
            // Staging env
            this.portals = [
                { name: this.translator.instant('end_consumers'), code: '3352144' },
                { name: this.translator.instant('hospitality_retail'), code: '3352124' },
                { name: this.translator.instant('specialty_roasters'), code: '3352128' },
                { name: this.translator.instant('estates'), code: '3352132' },
                { name: this.translator.instant('facilitator'), code: '3352136' },
                { name: this.translator.instant('roasters'), code: '3352060' },
            ];

            this.selectedPortals = [this.portals.find((portal) => portal.code === '3352144')];
        } else {
            // Prod env
            this.portals = [
                { name: this.translator.instant('end_consumers'), code: '3352052' },
                { name: this.translator.instant('hospitality_retail'), code: '3352048' },
                { name: this.translator.instant('specialty_roasters'), code: '3352044' },
                { name: this.translator.instant('estates'), code: '3352040' },
                { name: this.translator.instant('facilitator'), code: '3352036' },
                { name: this.translator.instant('roasters'), code: '3352032' },
            ];

            this.selectedPortals = [this.portals.find((portal) => portal.code === '3352052')];
        }
        this.form = this.fb.group({
            subscribeEmail: [
                '',
                [
                    Validators.required,
                    Validators.pattern(
                        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    ),
                ],
            ],
            subscribePortals: [this.portals],
        });
    }

    ngOnInit(): void {
        this.language = this.i18n.currentLang;
    }

    subscribe() {
        if (!this.form.value.subscribeEmail || !this.form.value.subscribeEmail.length) {
            this.messageService.add({
                key: 'myKey1',
                severity: 'error',
                summary: 'Please enter a valid email',
            });
            return;
        }

        this.tags = this.selectedPortals.map((portal) => portal.code);
        this.subscribeService.subscribeToList(this.form.value.subscribeEmail, this.tags).subscribe(
            (res: any) => {
                if (res.result && res.result === 'success') {
                    this.form.value.subscribeEmail = '';
                    this.form.value.subscribePortals = '';
                    this.messageService.add({
                        key: 'myKey1',
                        severity: 'success',
                        summary: this.globals.languageJson?.thankyou_subscribing,
                    });
                } else {
                    const summary = res.msg?.includes('already subscribed')
                        ? this.globals.languageJson?.email_already_subscribed
                        : this.globals.languageJson?.common_error;
                    this.messageService.add({
                        key: 'myKey1',
                        severity: 'error',
                        summary,
                    });
                }
            },
            (err) => {
                console.log(err);
            },
        );
    }

    changeLang(lang: string) {
        if (isPlatformBrowser(this.platformId)) {
            switch (lang) {
                case 'en':
                    window.location.href = '/op/coffee';
                    break;
                case 'sv':
                    window.location.href = '/op/kaffe';
                    break;
                default:
                    return;
            }
        }
    }
}
